<template>
  <component :is="tag" :class="{ 'is-open': isVisible, 'height-transition-wrapper': !isReducedMotion }">
    <component
      :is="innerTag"
      v-if="isNonexistent"
      :class="[innerClass, { 'height-transition-inner': !isReducedMotion }, 'focus-within:!overflow-visible']"
    >
      <slot></slot>
    </component>
  </component>
</template>

<script setup lang="ts">
  import { ref, watch, computed } from 'vue';
  import { usePreferredReducedMotion } from '@vueuse/core';

  const props = withDefaults(
    defineProps<{
      innerClass?: string;
      visible: boolean;
      tag?: keyof HTMLElementTagNameMap;
      innerTag?: keyof HTMLElementTagNameMap;
    }>(),
    {
      innerClass: '',
      tag: 'div',
      innerTag: 'div',
    }
  );

  const motion = usePreferredReducedMotion();
  const isReducedMotion = computed(() => motion.value === 'reduce');
  const isVisible = ref(props.visible);
  const isNonexistent = ref(props.visible);

  let timeout: NodeJS.Timeout;
  function setIsVisible(value: boolean) {
    if (value) {
      isVisible.value = value;
      isNonexistent.value = value;
      clearTimeout(timeout);
    } else {
      isVisible.value = value;
      if (!isReducedMotion.value) {
        timeout = setTimeout(() => {
          isNonexistent.value = value;
        }, 250);
      } else {
        isNonexistent.value = value;
      }
    }
  }

  watch(
    () => props.visible,
    () => setIsVisible(props.visible)
  );
</script>
